export const html = `
    html {
        font-family: "Quicksand", Helvetica, Arial, sans-serif;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 1.25;
    }
`
